export function getCaretPosition(element: HTMLElement): number {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return 0;

    const range = selection.getRangeAt(0);
    const preCaretRange = range.cloneRange();
    preCaretRange.selectNodeContents(element);
    preCaretRange.setEnd(range.endContainer, range.endOffset);
    return preCaretRange.toString().length;
}

export function setCaretPosition(element: HTMLElement, position: number) {
    const selection = window.getSelection();
    if (!selection) return;

    const range = document.createRange();
    let currentPos = 0;
    let found = false;

    function traverse(node: Node) {
        if (found) return;

        if (node.nodeType === Node.TEXT_NODE) {
            const textLength = node.textContent?.length || 0;
            if (currentPos + textLength >= position) {
                range.setStart(node, position - currentPos);
                range.collapse(true);
                found = true;
                return;
            }
            currentPos += textLength;
        } else {
            for (let i = 0; i < node.childNodes.length; i++) {
                const child = node.childNodes[i];
                if (child) traverse(child);
            }
        }
    }

    traverse(element);

    if (found) {
        selection.removeAllRanges();
        selection.addRange(range);
    }
}
